/** @format */

export const getTimestamp = () => {
  return -Math.floor(Date.now() / 1000);
};
